import { z } from 'zod';

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/svg+xml'];

export const AddCustomerSchema = z.object({
    first_name: z.string().min(1, 'The full name field is required.'),

    last_name: z.string().min(1, 'The full name field is required.'),
    company: z.string().optional(),
    linkedin: z
        .string()
        .optional()
        .refine(
            (val) =>
                !val ||
                /^https?:\/\/(www\.)?linkedin\.com\/.*$/i.test(val),
            {
                message: 'يرجى إدخال رابط LinkedIn صحيح',
            },
        ),
    phones: z
        .array(
            z
                .string()
                .transform((val) => val.trim())
                .refine((val) => val === '' || /^\d+$/.test(val), 'الرجاء إدخال أرقام فقط')
                .refine(
                    (val) => val === '' || (val.length >= 8 && val.length <= 15),
                    'يجب أن يتكون رقم الهاتف من 8 إلى 15 رقم',
                ),
        )
        .min(1, 'رقم الهاتف مطلوب')
        .max(2, 'يمكنك إضافة رقمين كحد أقصى')
        .superRefine((phones, ctx) => {
            if (!phones[0] || phones[0] === '') {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'رقم الهاتف مطلوب',
                    path: [0],
                });
            }
        }),

    email: z.preprocess(
        (val) => {
            if (val === '' || val === null || val === undefined) return '';
            return val;
        },
        z.union([z.literal(''), z.string().email('Please enter a valid email address.')]),
    ),

    address: z.string().optional(),
    // national_id: z    national_id.string().min(1, 'The national id number field is required.'),
    national_id: z
        .string()
        .optional()
        .refine(
            (val) => !val || /^\d{14}$/.test(val),
            {
                message: 'رقم الهوية الوطنية يجب أن يكون 14 رقمًا ويحتوي على أرقام فقط',
            }
        ),
    national_id_image_front: z
        .union([
            z
                .instanceof(File)
                .refine(
                    (file) => file.size <= MAX_FILE_SIZE,
                    `Image must be less than ${MAX_FILE_SIZE / (1024 * 1024)}MB`,
                )
                .refine(
                    (file) => ALLOWED_FILE_TYPES.includes(file.type),
                    'Only .jpeg, .png, .jpg, .gif, and .svg formats are allowed',
                ),
            z.undefined(),
            z.null(),
        ])
        .optional(),

    national_id_image_back: z
        .union([
            z
                .instanceof(File)
                .refine(
                    (file) => file.size <= MAX_FILE_SIZE,
                    `Image must be less than ${MAX_FILE_SIZE / (1024 * 1024)}MB`,
                )
                .refine(
                    (file) => ALLOWED_FILE_TYPES.includes(file.type),
                    'Only .jpeg, .png, .jpg, .gif, and .svg formats are allowed',
                ),
            z.undefined(),
            z.null(),
        ])
        .optional(),
    type: z
        .enum(['archive', 'contact', 'qualified', 'in_progress', 'completed'], {
            required_error: 'النوع مطلوب',
        })
        .optional(),
    // contact_period: z.preprocess((val) => {
    //     if (val === '' || val === null || val === undefined) return undefined;
    //     const num = Number(val);
    //     return isNaN(num) ? undefined : num;
    // }, z.number().int().optional()),
});

export type AddCustomerFormValues = z.infer<typeof AddCustomerSchema>;
